// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../../imageLarge.fragment.generated';
import { QuestionnaireQuestionChoiceOptionContentImageConditionalFragmentDoc } from './QuestionnaireQuestionChoiceOptionContentImageConditional.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentImageFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContentImage on QuestionnaireQuestionChoiceOptionContentImage {
  __typename
  image {
    url
    ...imageLarge
  }
  conditionalContent {
    ...questionnaireQuestionChoiceOptionContentImageConditional
  }
}
    ${ImageLargeFragmentDoc}
${QuestionnaireQuestionChoiceOptionContentImageConditionalFragmentDoc}`;